import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tick } from "./Icon.js";
import { cx } from "./cx.js";
export function EmptyState({ title, text, action, className }) {
    return (_jsxs("div", { className: cx("es", className), children: [_jsx("p", { className: "title-3 t-ink", style: { margin: 0 }, children: title }), text !== undefined && (_jsx("p", { className: "callout t-ink-3", style: { margin: 0 }, children: text })), action] }));
}
/**
 * Квадрат пункту плану: 22px, radius-1; зроблене — лайм із галочкою. Це
 * форма, а не колір: зроблене видно й без кольору.
 */
export function CheckBox({ on }) {
    return (_jsx("span", { className: cx("box", on && "box-on"), "aria-hidden": "true", children: _jsx(Tick, {}) }));
}
//# sourceMappingURL=Empty.js.map